export default __webpack_public_path__ + "static/11015-ab0bbfac8a3a55ee4dcbb3d960acfa16.jpg";